export default {
  title: 'Swap tokens',
  close: 'Close swap window',
  currentAccount: 'Swapping account: {{source}}',
  completeInWorldApp: 'Complete the swap in World App.',
  openWorldApp: 'Open World App Mini App',
  browserMetaMaskDescription: 'Browser swaps require MetaMask. On iPhone Safari, the official connection flow opens the MetaMask app and asks you to switch to World Chain when signing.',
  noPairs: 'No supported swap pairs are available. Currently supported: WLD ↔ BBT and WLD ↔ GGMOMOMO. BBG and BBT ↔ GGMOMOMO are not available yet.',
  payToken: 'Pay token',
  direction: 'Swap direction',
  reverseDirection: 'Reverse swap direction',
  receiveToken: 'Receive token',
  payAmount: 'Pay amount',
  expectedReceive: 'Expected receive',
  minimumReceive: 'Minimum receive',
  quoteLoading: 'Getting quote…',
  viewTransaction: 'View transaction: {{hash}}',
  successTitle: 'Swap successful',
  successMessage: '{{source}} completed the World Chain swap.',
  confirmedOutput: 'Actual received amount',
  quotedOutput: 'Estimated received amount',
  failedTitle: 'Swap failed',
  failedMessage: 'The transaction was submitted, but World Chain execution failed. The tokens were not swapped.',
  pendingTitle: 'Transaction pending',
  closeFeedback: 'Close notice',
  confirm: 'Confirm swap',
  browserMetaMaskOnly: 'Browser swaps can only be signed by MetaMask. Use World App for a World App account.',
  loginForAddress: 'Sign in first to get a World Chain wallet address.',
  connectForAddress: 'Connect MetaMask first to get a World Chain wallet address.',
  noTokenData: 'No on-chain token data is available. Refresh your balances first.',
  unsupportedPair: 'Only WLD ↔ BBT and WLD ↔ GGMOMOMO swaps are supported. BBG and BBT ↔ GGMOMOMO are not available yet.',
  enterAmount: 'Enter a swap amount.',
  waitForQuote: 'Wait for a valid quote before confirming the swap.',
  checkingApproval: 'Checking approval status…',
  approveWorldApp: 'Confirm token approval in World App.',
  approveMetaMask: 'Confirm token approval in MetaMask.',
  approveAndSwap: 'Confirm the approval and swap transaction together in World App.',
  updatingQuote: 'Updating the latest quote…',
  confirmWorldApp: 'Confirm the swap transaction in World App.',
  confirmMetaMask: 'Confirm the swap transaction in MetaMask.',
  waitingChain: 'Transaction submitted. Waiting for World Chain confirmation…',
  submitted: 'Swap submitted. Waiting for World Chain confirmation.',
  completed: 'Swap complete. Received {{amount}} {{symbol}}.',
  executionFailedStatus: 'The swap was responded to, but on-chain execution failed.',
  submittedSlow: 'Swap submitted; confirmation is taking longer. Refresh your balances later.',
  waitingWallet: 'Waiting for {{source}}…',
  transactionTitle: 'Swapping tokens…',
  transactionDescription: 'Swapping {{amount}} {{inputSymbol}} for {{outputSymbol}} in World App.',
  quoteError: 'Unable to get a quote: {{error}} Please confirm that this route is enabled and has liquidity.',
} as const;
